// 所有主题配置
export const THEMES = [
  {
    key: 'default',
    name: '暖橙',
    primary: '#ED6C00',
    primaryDark: '#d45f00',
    primaryLight: '#fff3e8',
    accent: '#ED6C00',
    navActive: '#ED6C00',
    bgPage: '#f5f6f8',
    bgGradientStart: '#FFF8F0',
    bgGradientEnd: '#FFEED9',
    previewColors: ['#ED6C00', '#ff9a44']
  },
  {
    key: 'blue',
    name: '科技蓝',
    primary: '#1890ff',
    primaryDark: '#096dd9',
    primaryLight: '#e6f7ff',
    accent: '#1890ff',
    navActive: '#1890ff',
    bgPage: '#f0f2f5',
    bgGradientStart: '#F3F8FF',
    bgGradientEnd: '#DFECFF',
    previewColors: ['#1890ff', '#096dd9']
  }
]

const app = {
  namespaced: true,
  state: {
    activeNav: '首页',
    themeKey: localStorage.getItem('themeKey') || 'default'
  },
  mutations: {
    SET_ACTIVE_NAV(state, nav) {
      state.activeNav = nav
    },
    SET_THEME(state, themeKey) {
      state.themeKey = themeKey
      localStorage.setItem('themeKey', themeKey)
    }
  },
  actions: {}
}

export default app
